<template>
  <div class="mx-sm-5 mx-xxs-3">
    <div class="d-flex flex-sm-row flex-xxs-column justify-content-center border border-success rounded">
      <div class="d-flex flex-column col bg-white text-success p-5 align-items-center">
        <h2 v-if="!subscriptionPlan.IsDailyPlan">
          {{ $t('UserProfile.PaymentHistory.RemainedSubscriptionDays', {'days':subscriptionPlan.RemainedDays}) }}
        </h2>
        <h4 v-if="subscriptionPlan.ActivePlan!== undefined" class="mt-4 mb-0">
          {{ $t('UserProfile.VoucherCard.SubscriptionPlan') }} {{ $t('UserProfile.VoucherCard.'+subscriptionPlan.ActivePlan) }}
        </h4>
      </div>
      <div class="d-flex flex-column col bg-success text-white p-5 align-items-center">
        <h2>
          {{ accounting.CurrentBalance }}
          {{ accounting.Unit }}
        </h2>
        <h4 class="mt-4 mb-0">
          {{ $t('UserProfile.PaymentHistory.CurrentBalance') }}
        </h4>
      </div>
    </div>

    <div class="mt-5">
      <div class="d-flex flex-row justify-content-between align-items-center">
        <h1>
          <small class="text-nowrap">
            {{ $t('UserProfile.PaymentHistory.Title') }}
          </small>
        </h1>
        <div class="d-flex w-75 border border-dark border-left-0 border-bottom-0 border-right-0" />
      </div>

      <div class="text-dark">
        <ul class="payment-items list-unstyled m-0">
          <li v-for="PaymentItem in paymentHistory.PaymentItems" :key="PaymentItem.id" class="payment-item position-relative shadow d-flex flex-sm-row flex-xxs-column mb-3 py-2 px-3" :class="PaymentItem.Type.toLowerCase()">
            <div class="d-flex flex-sm-column flex-xxs-row justify-content-between">
              <b-badge v-if="PaymentItem.Type == 'Successful'" variant="success" class="align-self-start">
                {{ $t('UserProfile.PaymentHistory.PaymentItem.Type.Successful') }}
              </b-badge>
              <b-badge v-else-if="PaymentItem.Type == 'Failed'" variant="danger" class="align-self-start">
                {{ $t('UserProfile.PaymentHistory.PaymentItem.Type.Failed') }}
              </b-badge>

              <span class="d-flex flex-column">
                <span class="pt-sm-3 pt-xxs-0 pb-2">
                  {{ PaymentItem.Date }}
                </span>
                <small>{{ PaymentItem.Time }}</small>
              </span>
            </div>
            <div class="d-flex border my-2 mx-2" />
            <div class="d-flex flex-sm-row flex-xxs-column justify-content-between w-100">
              <div class="d-flex flex-column mx-3">
                <strong class="lead py-3" :class="{'text-danger': PaymentItem.Type == 'Failed'}">
                  {{ PaymentItem.Title }}
                </strong>
                <small class="text-muted font-weight-light align-self-sm-start align-self-xxs-end d-sm-flex d-xxs-none">
                  {{ $t('UserProfile.PaymentHistory.PaymentItem.BankingFollowCode') }}
                  {{ PaymentItem.BankingFollowCode }}
                </small>
              </div>
              <div class="d-flex flex-sm-column flex-xxs-row mx-3 justify-content-sm-end justify-content-xxs-between">
                <small class="text-muted font-weight-light flex-column d-sm-none d-xxs-flex">
                  {{ $t('UserProfile.PaymentHistory.PaymentItem.BankingFollowCode') }}
                  {{ PaymentItem.BankingFollowCode }}
                </small>
                <div class="d-flex flex-column">
                  <span class="d-flex lead pb-3 mb-1 mt-0 align-self-center">
                    {{ PaymentItem.Amount }}
                    {{ $t('UserProfile.PaymentHistory.Currency.'+PaymentItem.PriceUnit) }}
                  </span>
                  <div class="barcode" />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserProfilePaymentHistory',
  props: {
    subscriptionPlan: Object,
    paymentHistory: Object,
    accounting: Object
  },
  computed: {
    ...mapGetters({

    })
  },
  methods: {
    ...mapActions({

    })
  },
  created () {

  },
  mounted () {

  }
}
</script>
